export default {
  computed: {
    maxExpiration() {
      if (this.linkShareFormData.LIMIT_EOD_MAX_EXPIRATION_VALUE) {
        const time = (this.linkShareFormData.LIMIT_EOD_MAX_EXPIRATION_VALUE - 1)
        * 24 * 60 * 60 * 1000
        const startTime = new Date(this.linkShareFormData.EOD_READ_START_TIME).getTime()
        const endTime = new Date(this.linkShareFormData.EOD_READ_END_TIME).getTime()
        if (endTime - startTime > time) {
          return this.$t('最多可选择{t}天', { t: this.linkShareFormData.LIMIT_EOD_MAX_EXPIRATION_VALUE })
        }
      }
      return false
    },
    maxReadDuration() {
      if (this.linkShareFormData.MAX_READ_DURATION) {
        if (!/^[1-9][0-9]{0,3}$/.test(this.linkShareFormData.MAX_READ_DURATION_VALUE)) {
          return this.$t('请输入正整数')
        }
        if (this.linkShareFormData.LIMIT_MAX_READ_DURATION_VALUE
          && (this.linkShareFormData.MAX_READ_DURATION_VALUE
            > this.linkShareFormData.LIMIT_MAX_READ_DURATION_VALUE)) {
          return this.$t('最多可阅读{t}小时', { t: this.linkShareFormData.LIMIT_MAX_READ_DURATION_VALUE })
        }
        return false
      }
      return false
    },
    maxReadTimes() {
      if (this.linkShareFormData.MAX_READ_TIMES) {
        if (!/^[1-9][0-9]{0,3}$/.test(this.linkShareFormData.MAX_READ_TIMES_VALUE)) {
          return this.$t('请输入正整数')
        }
        if (this.linkShareFormData.LIMIT_MAX_READ_TIMES_VALUE
          && (this.linkShareFormData.MAX_READ_TIMES_VALUE
            > this.linkShareFormData.LIMIT_MAX_READ_TIMES_VALUE)) {
          return this.$t('最多可阅读{t}次', { t: this.linkShareFormData.LIMIT_MAX_READ_TIMES_VALUE })
        }
        return false
      }
      return false
    },
    maxDownloadCount() {
      if (this.linkShareFormData.MAX_DOWNLOAD_COUNT) {
        if (!/^[1-9][0-9]{0,3}$/.test(this.linkShareFormData.MAX_DOWNLOAD_COUNT_VALUE)) {
          return this.$t('请输入正整数')
        }
        if (this.linkShareFormData.LIMIT_MAX_DOWNLOAD_COUNT_VALUE
          && (this.linkShareFormData.MAX_DOWNLOAD_COUNT_VALUE
            > this.linkShareFormData.LIMIT_MAX_DOWNLOAD_COUNT_VALUE)) {
          return this.$t('最多可下载{t}次', { t: this.linkShareFormData.LIMIT_MAX_DOWNLOAD_COUNT_VALUE })
        }
        return false
      }
      return false
    },
  },
}
